// covered-by: frontends/carrie/src/ask-v2/shell/__tests__/AskV2Shell.test.tsx
import { Heading, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

/**
 * Empty V2 product chrome. Proof that the Ask host is isolated from
 * `/ask-puntt` and the tickets layout. Product surfaces land here, not
 * in `src/routes/ask-puntt`.
 */
export function AskV2Shell() {
  const { t } = useTranslation("ui");

  return (
    <main
      data-testid="ask-v2-shell"
      aria-label={t("askV2.shell.title")}
      className="flex min-h-screen flex-col items-center justify-center gap-3 bg-base-white px-6"
    >
      <Heading
        as="h1"
        size="6"
        data-testid="ask-v2-shell-title"
        className="text-center"
      >
        {t("askV2.shell.title")}
      </Heading>
      <Text
        as="p"
        size="3"
        data-testid="ask-v2-shell-subtitle"
        className="max-w-md text-center text-puntt-neutral-gray-11"
      >
        {t("askV2.shell.subtitle")}
      </Text>
    </main>
  );
}
